export const naturalSort = (a, b, language) => {
  // Intl Collator can help us sort diacritics and other idiosyncracies across languages, supported on 95% of browsers (including IE).
  // Setting "sensitivity" to "base" ignores case sensitivity, and "numeric" to "true" sorts alphanumerically
  return new Intl.Collator(language || undefined, {
    numeric: true,
    sensitivity: "base",
  }).compare(a, b);
};
